import type { JobAdsResult } from "@/modules/jobAds/client/api/types"

import { useContext } from "react"

import { useJobAdsFetch } from "@/modules/companies/client/hooks/useJobAdsFetch"
import { JobAdsFetchContext } from "@/modules/jobAds/client/components/JobAdsFetchProvider/JobAdsFetchProvider"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"

export type JobAdsFetch = {
  dataJobAds?: JobAdsResult
  isLoadingJobAds: boolean
  isSuccessJobAds: boolean
  isErrorJobAds: boolean
}

export const useJobAdsFetchContext = (): JobAdsFetch & {
  isAlgoliaEnabled?: boolean
} => {
  const context = useContext(JobAdsFetchContext)
  const isAlgoliaEnabled = context?.isAlgoliaEnabled

  const dataHook = isAlgoliaEnabled ? useJobAdsFromAlgolia : useJobAdsFetch

  if (!context) {
    throw new Error(`Missing job ads fetch context when fetching job ads data.`)
  }

  return {
    ...dataHook(),
    isAlgoliaEnabled: context.isAlgoliaEnabled,
  }
}
